module.exports = "/images/logo.svg";